/* eslint-disable */
import { ReactNode } from "react";
import RootStore from '../stores/RootStore';
import { RootStoreContext } from '../stores/root-store-context';
import FaqApiClient from '../api/FAQApi';
import { defaultConfigApi } from '../api/base/defaultConfigApi';

const rootStore = new RootStore(new FaqApiClient(defaultConfigApi));

interface RootStoreProviderProps {
  children: ReactNode;
}

export const RootStoreProvider = ({ children }: RootStoreProviderProps) => (
  <RootStoreContext.Provider value={rootStore}>
    {children}
  </RootStoreContext.Provider>
);